// extracted by mini-css-extract-plugin
module.exports = {"header":"components-FormTemplate-FormTemplateAgent-FormTemplateAgent__header--2vPmx"};